// Conversión de decimales entre formato de UI ("12,5") y formato de BD ("12.5").

export const estaVacio = valor => valor === null || valor === undefined || valor === "";

export const decimalToBD = decimal => {
    if (estaVacio(decimal)) {
        return null;
    }
    return decimal.toString().replace(",", ".");
};

export const decimalFromBD = decimal => {
    if (decimal == null) {
        return null;
    }
    return decimal.toString().replace(".", ",");
};
